// Central translations file — FR / EN

export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "Parcours",
      specialties: "Spécialités",
      sport: "Sport",
      locations: "Lieux",
      expertise: "Expertise judiciaire",
      blog: "Actualités",
      faq: "FAQ",
      contact: "Contact",
      bookRdv: "Prendre RDV",
      doctolib: "Doctolib",
    },

    hero: {
      eyebrow: "Institut Marseillais d'Orthopédie, de Traumatologie et de l'Épaule du Sportif",
      titleLine1: "Dr Richard",
      titleLine2: "ASWAD",
      subtitle:
        "Chirurgien orthopédique du membre supérieur. Épaule, coude, main, microchirurgie, arthroscopie. Traumatologie du sport à Marseille.",
      ctaPrimary: "Prendre rendez-vous",
      ctaSecondary: "Découvrir le parcours",
      statExperience: "Années d'expérience",
      statInterventions: "Interventions",
      statPublications: "Publications",
      trustRow: "Membre SOFCOT · SOFEC · SFA · SECEC · Expert HAS",
    },

    about: {
      eyebrow: "Parcours",
      title: "Une trajectoire internationale au service de l'excellence",
      lead:
        "Formé à Paris (CHU Saint-Antoine), puis à l'Université de Toronto et à la Mayo Clinic (Rochester), le Dr Richard Aswad consacre sa pratique à la chirurgie du membre supérieur depuis plus de 25 ans.",
      milestones: [
        {
          year: "1994",
          title: "Faculté de Médecine — Paris VI",
          text: "Externat des hôpitaux de Paris, promotion internat 1991. Formation initiale au CHU Saint-Antoine.",
        },
        {
          year: "1997",
          title: "Fellowship — Université de Toronto",
          text: "Plastic Surgery & Hand Surgery avec Pr. Ralph Manktelow. Microchirurgie du membre supérieur.",
        },
        {
          year: "1998",
          title: "Clinical Fellow — Lausanne",
          text: "Chirurgie de la main et des nerfs périphériques auprès du Dr Chantal Bonnard.",
        },
        {
          year: "1999–2002",
          title: "Fellowships Mayo Clinic — Rochester",
          text: "Chirurgie de la main, du coude, de l'épaule et des nerfs périphériques. Programme coude sur 5 ans.",
        },
        {
          year: "1999–2000",
          title: "Chef de Clinique — Marseille",
          text: "Assistant des hôpitaux de Marseille, service du Pr. Louis (chirurgie du rachis).",
        },
        {
          year: "Aujourd'hui",
          title: "IMOTEpS — Clinique Juge",
          text: "Coordonnateur régional DIU Épaule & Coude. Expert HAS pour les prothèses d'épaule. Reviewer JSES.",
        },
      ],
      titles: [
        "Médecin Expert à la CARMF",
        "Expert HAS pour les prothèses d'épaule",
        "Reviewer JSES (Journal of Shoulder and Elbow Surgery) & CRO",
        "Trésorier adjoint — Conseil départemental Bouches-du-Rhône",
        "Coordonnateur régional DIU Chirurgie Épaule & Coude",
        "Co-responsable du DIU Épaule & Coude — Faculté de Marseille",
      ],
      valuesTitle: "Une pratique guidée par trois principes",
      values: [
        {
          icon: "stethoscope",
          title: "Écoute & diagnostic précis",
          text:
            "Chaque consultation démarre par une analyse approfondie : examen clinique, imagerie ciblée, temps de dialogue.",
        },
        {
          icon: "microscope",
          title: "Techniques mini-invasives",
          text:
            "Arthroscopie, microchirurgie, planification 3D — des gestes ciblés pour des cicatrices discrètes et une récupération rapide.",
        },
        {
          icon: "heart-pulse",
          title: "Suivi humain jusqu'à la reprise",
          text:
            "Travail d'équipe avec kinésithérapeutes, médecins du sport et rééducateurs pour un retour optimal aux activités.",
        },
      ],
    },

    specialties: {
      eyebrow: "Spécialités chirurgicales",
      title: "Expertise du membre supérieur, du geste au retour en pleine forme",
      lead:
        "Chirurgie moderne, techniques éprouvées et innovations maîtrisées — pour chaque articulation du membre supérieur.",
      viewAll: "Voir toutes les pathologies traitées",
      cards: [
        {
          slug: "epaule",
          icon: "fa-user-doctor",
          title: "Épaule",
          short:
            "Rupture de coiffe, instabilité, prothèses anatomiques et inversées, arthroscopie.",
          bullets: [
            "Ruptures de la coiffe des rotateurs",
            "Instabilité (Latarjet, Bankart arthroscopique)",
            "Prothèses anatomiques & inversées",
            "Luxations acromio-claviculaires",
            "Conflit sous-acromial, calcifications",
          ],
        },
        {
          slug: "coude",
          icon: "fa-bone",
          title: "Coude",
          short:
            "Épicondylite, raideurs, arthrose, arthroscopie du coude, rupture distale du biceps.",
          bullets: [
            "Arthroscopie du coude",
            "Tennis-elbow & golfer-elbow",
            "Rupture du biceps distal",
            "Raideurs post-traumatiques",
            "Prothèses du coude",
          ],
        },
        {
          slug: "main-poignet",
          icon: "fa-hand",
          title: "Main & Poignet",
          short:
            "Canal carpien, Dupuytren, fractures, arthrose, traumatismes digitaux.",
          bullets: [
            "Canal carpien, canal de Guyon",
            "Maladie de Dupuytren",
            "Fractures du radius distal",
            "Rhizarthrose",
            "Ligaments & tendons",
          ],
        },
        {
          slug: "microchirurgie",
          icon: "fa-diamond",
          title: "Microchirurgie",
          short:
            "Sutures nerveuses, réimplantations digitales, lambeaux libres — sous microscope opératoire.",
          bullets: [
            "Réimplantations digitales",
            "Réparations nerveuses",
            "Transferts nerveux & musculaires",
            "Lambeaux libres vascularisés",
            "Urgences microchirurgicales",
          ],
        },
        {
          slug: "arthroscopie",
          icon: "fa-magnifying-glass",
          title: "Arthroscopie",
          short:
            "Techniques mini-invasives de l'épaule, du coude et du poignet : précision, récupération rapide.",
          bullets: [
            "Arthroscopie de l'épaule",
            "Arthroscopie du coude",
            "Arthroscopie du poignet",
            "Ambulatoire si possible",
            "Protocoles de récupération rapide",
          ],
        },
        {
          slug: "membre-superieur",
          icon: "fa-hand-fist",
          title: "Membre Supérieur",
          short:
            "Prise en charge globale, du plexus brachial aux doigts — diagnostic, chirurgie, réadaptation.",
          bullets: [
            "Plexus brachial",
            "Compressions nerveuses",
            "Transferts tendineux",
            "Pathologies dégénératives",
            "Traumatologie complexe",
          ],
        },
      ],
    },

    sport: {
      eyebrow: "Traumatologie du Sport",
      title: "Sportifs amateurs, professionnels, élites — un même objectif : votre reprise.",
      lead:
        "25 ans de prise en charge des sportifs. Le Dr Aswad accompagne rugbymen, tennismen, nageurs, lanceurs et athlètes de haut niveau dans leur retour au jeu — avec des protocoles éprouvés.",
      pillars: [
        {
          icon: "fa-dumbbell",
          title: "Diagnostic de performance",
          text: "Examen clinique et imagerie ciblée (échographie dynamique, IRM, arthro-scanner).",
        },
        {
          icon: "fa-person-running",
          title: "Techniques mini-invasives",
          text: "Arthroscopie et microchirurgie pour préserver les tissus et accélérer la reprise.",
        },
        {
          icon: "fa-medal",
          title: "Retour au sport structuré",
          text: "Protocoles de réathlétisation avec kinés et préparateurs physiques partenaires.",
        },
      ],
      disciplines: [
        "Rugby",
        "Tennis",
        "Moto",
        "Motocross",
        "Natation",
        "Handball",
        "Volley-ball",
        "Golf",
        "Judo",
        "Escalade",
        "Crossfit",
        "Basketball",
      ],
      ctaLabel: "Discuter d'une reprise sportive",
    },

    locations: {
      eyebrow: "Lieux de consultation & opération",
      title: "Un site d'excellence au cœur de Marseille",
      lead:
        "Consultations, examens pré-opératoires et interventions chirurgicales — un plateau technique moderne au sein de structures reconnues.",
      sites: [
        {
          name: "Clinique Juge",
          role: "Consultations · Chirurgie programmée",
          address: "118, Rue Jean Mermoz",
          city: "13008 Marseille",
          phone: "+33 4 88 60 02 16",
          mapsUrl: "https://www.google.com/maps/search/?api=1&query=Clinique+Juge+118+Rue+Jean+Mermoz+Marseille",
          image: "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/3nqm48jv_unnamed.webp",
        },
      ],
      accessTitle: "Accès & parking",
      accessText:
        "Parking visiteurs sur place · Tramway T3 et bus à proximité · Accès PMR.",
    },

    expertise: {
      eyebrow: "Expertise judiciaire",
      title: "Médecin expert reconnu auprès des tribunaux",
      lead:
        "Le Dr Aswad réalise des expertises médicales dans le cadre de dossiers de responsabilité civile, pénale ou assurantielle — avec la rigueur et l'objectivité attendues.",
      missions: [
        "Expertise médicale à la CARMF",
        "Expert nommé à la Haute Autorité de Santé pour les prothèses d'épaule",
        "Expertises judiciaires — préjudice corporel",
        "Expertises assurantielles & médiations",
        "Reviewer scientifique JSES & CRO",
      ],
      contactCta: "Demander une expertise",
    },

    faq: {
      eyebrow: "FAQ Patients",
      title: "Vos questions, nos réponses",
      items: [
        {
          q: "Comment prendre rendez-vous avec le Dr Aswad ?",
          a: "Vous pouvez réserver directement via Doctolib, par téléphone au +33 4 88 60 02 16 ou en remplissant le formulaire de contact. L'assistante du Dr Aswad, Fabienne (+33 4 88 60 02 15 — fabienne.imoteps13@gmail.com), vous recontactera dans les 48 heures ouvrées.",
        },
        {
          q: "Quels documents apporter en consultation ?",
          a: "Munissez-vous de votre carte Vitale, d'une pièce d'identité, de votre mutuelle, d'un courrier de votre médecin traitant le cas échéant, et de l'ensemble de vos imageries (IRM, radiographies, échographies) sur CD ou clé USB.",
        },
        {
          q: "Quels sont les délais de récupération après une chirurgie de l'épaule ?",
          a: "Les délais varient selon l'intervention : réparation de coiffe (3 à 6 mois), instabilité par Latarjet (4 mois), prothèse totale (3 mois). Un protocole de rééducation personnalisé est remis à chaque patient.",
        },
        {
          q: "L'arthroscopie est-elle systématiquement proposée ?",
          a: "L'arthroscopie est indiquée chaque fois qu'elle offre un résultat équivalent ou supérieur à la chirurgie ouverte. Le Dr Aswad privilégie les techniques mini-invasives quand les conditions anatomiques le permettent.",
        },
        {
          q: "Pratiquez-vous l'ambulatoire ?",
          a: "Oui, de très nombreuses interventions (canal carpien, arthroscopie, ablation de matériel) sont réalisées en ambulatoire : vous rentrez chez vous le jour même, avec un suivi personnalisé.",
        },
        {
          q: "Quelles sont les modalités d'une expertise judiciaire ?",
          a: "Les expertises se font sur mandat (ordonnance de tribunal, désignation d'assurance ou mission amiable). Un dossier complet est demandé. Les honoraires sont fixés selon la grille CARMF et transmis au préalable.",
        },
      ],
    },

    testimonials: {
      eyebrow: "Ils témoignent",
      title: "La confiance de patients et de sportifs",
      lead:
        "Chaque parcours est unique. Voici quelques retours de patients opérés par le Dr Aswad.",
    },

    blog: {
      eyebrow: "Actualités & articles",
      title: "Mieux comprendre sa pathologie",
      lead:
        "Décryptages, innovations chirurgicales et conseils pratiques rédigés par le Dr Aswad.",
      readMore: "Lire l'article",
      viewAll: "Voir tous les articles",
      minRead: "min de lecture",
    },

    contact: {
      eyebrow: "Contact",
      title: "Une question ? Un projet chirurgical ?",
      lead:
        "Formulaire sécurisé — le secrétariat vous répond sous 48 h ouvrées. Pour les urgences, composez le 15.",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      reason: "Motif",
      reasonOptions: [
        { value: "consultation", label: "Prise de rendez-vous" },
        { value: "sport", label: "Traumatologie du sport" },
        { value: "expertise", label: "Expertise judiciaire" },
        { value: "other", label: "Autre" },
      ],
      subject: "Sujet",
      message: "Votre message",
      submit: "Envoyer le message",
      submitting: "Envoi en cours...",
      success: "Message bien envoyé. Le secrétariat vous recontacte rapidement.",
      error: "Une erreur est survenue. Merci de réessayer.",
      phoneLabel: "Téléphone",
      emailLabel: "Email",
      addressLabel: "Adresse",
    },

    footer: {
      about:
        "L'IMOTEpS est l'Institut Marseillais d'Orthopédie, de Traumatologie et de l'Épaule du Sportif fondé par le Dr Richard Aswad. Spécialisé en chirurgie de l'épaule et du membre supérieur à Marseille (13008), nous prenons en charge sportifs amateurs et de haut niveau pour les pathologies de la coiffe des rotateurs, l'instabilité de l'épaule, l'arthrose, les fractures et les urgences traumatiques de l'épaule, du coude, du poignet et de la main.",
      quickLinks: "Navigation",
      contact: "Contact",
      legal: "Informations légales",
      legalLinks: [
        { label: "Mentions légales", href: "/mentions-legales" },
        { label: "Politique de confidentialité", href: "/confidentialite" },
        { label: "RGPD", href: "/rgpd" },
      ],
      copyright: "© 2025 Dr Richard Aswad — IMOTEpS. Tous droits réservés.",
      emergency: "Urgence vitale : composez le 15 (SAMU)",
      expertiseTitle: "Pôles d'expertise",
      expertiseLinks: [
        { label: "Chirurgie de l'épaule à Marseille", href: "/chirurgie-epaule-marseille" },
        { label: "Chirurgie du bras", href: "/chirurgie-bras-marseille" },
        { label: "Luxation de l'épaule", href: "/luxation-epaule-marseille" },
        { label: "Fracture du bras", href: "/fracture-bras-marseille" },
        { label: "Fracture de la main", href: "/fracture-main-marseille" },
        { label: "Orthopédie du membre supérieur", href: "/orthopedie-membre-superieur-marseille" },
        { label: "Orthopédie de la main", href: "/orthopedie-main-marseille" },
        { label: "Épaule du sportif", href: "/epaule-du-sportif" },
        { label: "Urgences de l'épaule", href: "/urgences-epaule" },
        { label: "Rupture de la coiffe des rotateurs", href: "/pathologie/coiffe-rotateurs" },
        { label: "Instabilité & luxation de l'épaule", href: "/pathologie/instabilite-epaule" },
        { label: "Capsulite rétractile (épaule gelée)", href: "/pathologie/capsulite-retractile" },
        { label: "Prothèse d'épaule", href: "/pathologie/prothese-epaule" },
        { label: "Tennis-elbow (épicondylite)", href: "/pathologie/epicondylite" },
        { label: "Syndrome du canal carpien", href: "/pathologie/canal-carpien" },
      ],
      seoTagline:
        "Cabinet d'orthopédie reconnu à Marseille — Clinique Juge, Monticelli-Vélodrome, Bouchard. Consultations 13008, prise en charge des sportifs blessés, expertises judiciaires et urgences du membre supérieur.",
    },

    gallery: {
      eyebrow: "Galerie",
      title: "Résultats chirurgicaux — avant / après",
      lead:
        "Images anonymisées, publiées avec consentement. Chaque cas est unique, les résultats illustrés ne sauraient être considérés comme une promesse.",
    },

    common: {
      learnMore: "En savoir plus",
      seeDetails: "Voir les détails",
      back: "Retour",
      readingTime: "min",
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "Background",
      specialties: "Specialties",
      sport: "Sports",
      locations: "Locations",
      expertise: "Legal Expertise",
      blog: "News",
      faq: "FAQ",
      contact: "Contact",
      bookRdv: "Book Appointment",
      doctolib: "Doctolib",
    },

    hero: {
      eyebrow: "Marseille Institute of Orthopedics, Traumatology and Sports Shoulder",
      titleLine1: "Dr Richard",
      titleLine2: "ASWAD",
      subtitle:
        "Upper-limb orthopedic surgeon. Shoulder, elbow, hand, microsurgery, arthroscopy. Sports traumatology in Marseille.",
      ctaPrimary: "Book an appointment",
      ctaSecondary: "Discover the journey",
      statExperience: "Years of practice",
      statInterventions: "Interventions",
      statPublications: "Publications",
      trustRow: "Member SOFCOT · SOFEC · SFA · SECEC · HAS Expert",
    },

    about: {
      eyebrow: "Background",
      title: "An international journey dedicated to excellence",
      lead:
        "Trained in Paris (CHU Saint-Antoine), then at the University of Toronto and the Mayo Clinic (Rochester), Dr Richard Aswad has dedicated his practice to upper-limb surgery for over 25 years.",
      milestones: [
        {
          year: "1994",
          title: "Faculty of Medicine — Paris VI",
          text: "Externship at Paris hospitals, 1991 residency class. Initial training at CHU Saint-Antoine.",
        },
        {
          year: "1997",
          title: "Fellowship — University of Toronto",
          text: "Plastic Surgery & Hand Surgery with Prof. Ralph Manktelow. Upper-limb microsurgery.",
        },
        {
          year: "1998",
          title: "Clinical Fellow — Lausanne",
          text: "Hand and peripheral nerve surgery with Dr Chantal Bonnard.",
        },
        {
          year: "1999–2002",
          title: "Mayo Clinic Fellowships — Rochester",
          text: "Hand, elbow, shoulder and peripheral nerve surgery. 5-year elbow program.",
        },
        {
          year: "1999–2000",
          title: "Chief Resident — Marseille",
          text: "Hospital assistant in Marseille, Prof. Louis department (spine surgery).",
        },
        {
          year: "Today",
          title: "IMOTEpS — Clinique Juge",
          text: "Regional DIU coordinator Shoulder & Elbow. HAS expert for shoulder prostheses. JSES reviewer.",
        },
      ],
      titles: [
        "Medical Expert — CARMF",
        "HAS Expert for shoulder prostheses",
        "Reviewer JSES & CRO journals",
        "Deputy Treasurer — Bouches-du-Rhône Medical Council",
        "Regional DIU Coordinator — Shoulder & Elbow Surgery",
        "Co-head of DIU Shoulder & Elbow — Marseille Faculty",
      ],
      valuesTitle: "A practice guided by three principles",
      values: [
        {
          icon: "stethoscope",
          title: "Listening & precise diagnosis",
          text:
            "Every consultation begins with a thorough analysis: clinical exam, targeted imaging, real conversation.",
        },
        {
          icon: "microscope",
          title: "Minimally-invasive techniques",
          text:
            "Arthroscopy, microsurgery, 3D planning — precise gestures for minimal scars and fast recovery.",
        },
        {
          icon: "heart-pulse",
          title: "Human follow-up until return",
          text:
            "Teamwork with physiotherapists, sports physicians and rehab specialists for optimal return to activity.",
        },
      ],
    },

    specialties: {
      eyebrow: "Surgical specialties",
      title: "Upper-limb expertise — from surgery to peak recovery",
      lead:
        "Modern surgery, proven techniques and mastered innovations — for every upper-limb joint.",
      viewAll: "View all treated conditions",
      cards: [
        {
          slug: "shoulder",
          icon: "fa-user-doctor",
          title: "Shoulder",
          short:
            "Rotator cuff tears, instability, anatomical and reverse prostheses, arthroscopy.",
          bullets: [
            "Rotator cuff repairs",
            "Instability (Latarjet, arthroscopic Bankart)",
            "Anatomical & reverse prostheses",
            "Acromio-clavicular dislocations",
            "Sub-acromial impingement, calcifications",
          ],
        },
        {
          slug: "elbow",
          icon: "fa-bone",
          title: "Elbow",
          short:
            "Epicondylitis, stiffness, osteoarthritis, elbow arthroscopy, distal biceps rupture.",
          bullets: [
            "Elbow arthroscopy",
            "Tennis & golfer's elbow",
            "Distal biceps rupture",
            "Post-traumatic stiffness",
            "Elbow prostheses",
          ],
        },
        {
          slug: "hand-wrist",
          icon: "fa-hand",
          title: "Hand & Wrist",
          short:
            "Carpal tunnel, Dupuytren, fractures, arthritis, digital trauma.",
          bullets: [
            "Carpal tunnel, Guyon's canal",
            "Dupuytren's disease",
            "Distal radius fractures",
            "Rhizarthrosis",
            "Ligament & tendon surgery",
          ],
        },
        {
          slug: "microsurgery",
          icon: "fa-diamond",
          title: "Microsurgery",
          short:
            "Nerve sutures, digital replantations, free flaps — under an operating microscope.",
          bullets: [
            "Digital replantations",
            "Nerve repairs",
            "Nerve & muscle transfers",
            "Free vascularized flaps",
            "Microsurgical emergencies",
          ],
        },
        {
          slug: "arthroscopy",
          icon: "fa-magnifying-glass",
          title: "Arthroscopy",
          short:
            "Minimally-invasive shoulder, elbow and wrist techniques: precision, fast recovery.",
          bullets: [
            "Shoulder arthroscopy",
            "Elbow arthroscopy",
            "Wrist arthroscopy",
            "Ambulatory when possible",
            "Fast-recovery protocols",
          ],
        },
        {
          slug: "upper-limb",
          icon: "fa-hand-fist",
          title: "Upper Limb",
          short:
            "Comprehensive management, from brachial plexus to fingers — diagnosis, surgery, rehabilitation.",
          bullets: [
            "Brachial plexus",
            "Nerve compressions",
            "Tendon transfers",
            "Degenerative conditions",
            "Complex trauma",
          ],
        },
      ],
    },

    sport: {
      eyebrow: "Sports Traumatology",
      title: "Amateurs, pros, elite athletes — one goal: your return.",
      lead:
        "25 years of managing athletes. Dr Aswad supports rugby players, tennis players, swimmers, throwers and elite athletes in their return to play — with proven protocols.",
      pillars: [
        {
          icon: "fa-dumbbell",
          title: "Performance diagnosis",
          text: "Clinical exam and targeted imaging (dynamic ultrasound, MRI, arthro-CT).",
        },
        {
          icon: "fa-person-running",
          title: "Minimally-invasive techniques",
          text: "Arthroscopy and microsurgery to preserve tissues and accelerate return.",
        },
        {
          icon: "fa-medal",
          title: "Structured return to sport",
          text: "Re-athletic protocols with partner physios and strength coaches.",
        },
      ],
      disciplines: [
        "Rugby",
        "Tennis",
        "Motorcycle",
        "Motocross",
        "Swimming",
        "Handball",
        "Volleyball",
        "Golf",
        "Judo",
        "Climbing",
        "Crossfit",
        "Basketball",
      ],
      ctaLabel: "Discuss your comeback",
    },

    locations: {
      eyebrow: "Consultation & surgery sites",
      title: "A site of excellence in the heart of Marseille",
      lead:
        "Consultations, pre-operative work-up and surgical procedures — modern facilities within renowned institutions.",
      sites: [
        {
          name: "Clinique Juge",
          role: "Consultations · Scheduled surgery",
          address: "118, Rue Jean Mermoz",
          city: "13008 Marseille",
          phone: "+33 4 88 60 02 16",
          mapsUrl: "https://www.google.com/maps/search/?api=1&query=Clinique+Juge+118+Rue+Jean+Mermoz+Marseille",
          image: "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/3nqm48jv_unnamed.webp",
        },
      ],
      accessTitle: "Access & parking",
      accessText:
        "On-site visitor parking · Tram T3 & buses nearby · Accessible for reduced mobility.",
    },

    expertise: {
      eyebrow: "Legal Expertise",
      title: "Recognized medical expert before the courts",
      lead:
        "Dr Aswad conducts medical expertise in civil, criminal and insurance liability cases — with the rigor and objectivity expected.",
      missions: [
        "Medical expertise at CARMF",
        "Appointed HAS expert for shoulder prostheses",
        "Judicial expertise — bodily injury",
        "Insurance expertise & mediations",
        "Scientific reviewer JSES & CRO",
      ],
      contactCta: "Request an expertise",
    },

    faq: {
      eyebrow: "Patient FAQ",
      title: "Your questions, our answers",
      items: [
        {
          q: "How do I book an appointment with Dr Aswad?",
          a: "You can book directly via Doctolib, by phone at +33 4 88 60 02 16, or by filling in the contact form. Dr Aswad's assistant Fabienne (+33 4 88 60 02 15 — fabienne.imoteps13@gmail.com) will get back to you within 48 business hours.",
        },
        {
          q: "What documents should I bring to a consultation?",
          a: "Please bring your carte Vitale, ID, health insurance details, a letter from your GP if relevant, and all imaging (MRI, X-rays, ultrasound) on CD or USB key.",
        },
        {
          q: "What are recovery times after shoulder surgery?",
          a: "Times vary: rotator cuff repair (3–6 months), Latarjet (4 months), total prosthesis (3 months). A personalized rehab protocol is provided to every patient.",
        },
        {
          q: "Is arthroscopy always offered?",
          a: "Arthroscopy is proposed whenever it offers equivalent or better outcomes than open surgery. Dr Aswad favors minimally-invasive techniques when anatomy permits.",
        },
        {
          q: "Do you perform day-surgery?",
          a: "Yes, many interventions (carpal tunnel, arthroscopy, hardware removal) are performed as day-surgery: you go home the same day, with personalized follow-up.",
        },
        {
          q: "How does a legal expertise work?",
          a: "Expertise is conducted under mandate (court order, insurance designation or amicable mission). A complete file is required. Fees follow the CARMF schedule and are communicated beforehand.",
        },
      ],
    },

    testimonials: {
      eyebrow: "Patient stories",
      title: "The trust of patients and athletes",
      lead:
        "Every journey is unique. Here are some words from patients operated by Dr Aswad.",
    },

    blog: {
      eyebrow: "News & articles",
      title: "Better understanding your condition",
      lead:
        "In-depth articles, surgical innovations and practical advice written by Dr Aswad.",
      readMore: "Read article",
      viewAll: "View all articles",
      minRead: "min read",
    },

    contact: {
      eyebrow: "Contact",
      title: "A question? A surgical project?",
      lead:
        "Secure form — the secretariat replies within 48 business hours. For emergencies, dial 15.",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      reason: "Reason",
      reasonOptions: [
        { value: "consultation", label: "Book an appointment" },
        { value: "sport", label: "Sports traumatology" },
        { value: "expertise", label: "Legal expertise" },
        { value: "other", label: "Other" },
      ],
      subject: "Subject",
      message: "Your message",
      submit: "Send message",
      submitting: "Sending...",
      success: "Message sent. The secretariat will contact you shortly.",
      error: "An error occurred. Please try again.",
      phoneLabel: "Phone",
      emailLabel: "Email",
      addressLabel: "Address",
    },

    footer: {
      about:
        "IMOTEpS is the Marseille Institute of Orthopedics, Traumatology and Sports Shoulder, founded by Dr Richard Aswad. Specialized in shoulder and upper-limb surgery in Marseille (13008), we treat amateur and elite athletes for rotator cuff tears, shoulder instability, osteoarthritis, fractures and traumatic emergencies of the shoulder, elbow, wrist and hand.",
      quickLinks: "Navigation",
      contact: "Contact",
      legal: "Legal information",
      legalLinks: [
        { label: "Legal notice", href: "/mentions-legales" },
        { label: "Privacy policy", href: "/confidentialite" },
        { label: "GDPR", href: "/rgpd" },
      ],
      copyright: "© 2025 Dr Richard Aswad — IMOTEpS. All rights reserved.",
      emergency: "Medical emergency: dial 15 (SAMU)",
      expertiseTitle: "Areas of expertise",
      expertiseLinks: [
        { label: "Shoulder surgery in Marseille", href: "/chirurgie-epaule-marseille" },
        { label: "Arm surgery", href: "/chirurgie-bras-marseille" },
        { label: "Shoulder dislocation", href: "/luxation-epaule-marseille" },
        { label: "Arm fracture", href: "/fracture-bras-marseille" },
        { label: "Hand fracture", href: "/fracture-main-marseille" },
        { label: "Upper limb orthopedics", href: "/orthopedie-membre-superieur-marseille" },
        { label: "Hand orthopedics", href: "/orthopedie-main-marseille" },
        { label: "Sports shoulder", href: "/epaule-du-sportif" },
        { label: "Shoulder emergencies", href: "/urgences-epaule" },
        { label: "Rotator cuff tear", href: "/pathologie/coiffe-rotateurs" },
        { label: "Shoulder instability & dislocation", href: "/pathologie/instabilite-epaule" },
        { label: "Frozen shoulder", href: "/pathologie/capsulite-retractile" },
        { label: "Shoulder prosthesis", href: "/pathologie/prothese-epaule" },
        { label: "Tennis elbow", href: "/pathologie/epicondylite" },
        { label: "Carpal tunnel syndrome", href: "/pathologie/canal-carpien" },
      ],
      seoTagline:
        "Recognized orthopedic practice in Marseille — Clinique Juge, Monticelli-Vélodrome, Bouchard. Consultations 13008, care for injured athletes, legal expertise and upper-limb emergencies.",
    },

    gallery: {
      eyebrow: "Gallery",
      title: "Surgical results — before / after",
      lead:
        "Anonymized images, published with consent. Every case is unique; shown results must not be taken as a promise.",
    },

    common: {
      learnMore: "Learn more",
      seeDetails: "See details",
      back: "Back",
      readingTime: "min",
    },
  },
};

export default translations;
